import { columnTwoIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Sections = createIcon({
  displayName: 'Sections',
  paths: [
    'M810.667 768h-341.333v-213.333h384v170.667c0 23.509-19.157 42.667-42.667 42.667zM853.333 298.667v170.667h-384v-213.333h341.333c23.509 0 42.667 19.157 42.667 42.667zM213.333 768c-23.509 0-42.667-19.157-42.667-42.667v-426.667c0-23.509 19.157-42.667 42.667-42.667h170.667v512h-170.667zM810.667 170.667h-597.333c-70.699 0-128 57.301-128 128v426.667c0 70.699 57.301 128 128 128h597.333c70.699 0 128-57.301 128-128v-426.667c0-70.699-57.301-128-128-128z'
  ],
  canvasPaths: canvasIconPaths(columnTwoIcon)
})
